import orderBy from "lodash/orderBy";
import { schema } from "normalizr";

export const spaceSchema = new schema.Entity(
  "spaces",
  {},
  {
    processStrategy: (space) => ({
      ...space,
      prices: orderBy(space.prices, "value", "desc"),
    }),
  }
);
export const spacesSchema = [spaceSchema];

export default spacesSchema;
